<template>
  <Transition enter-active-class="slideInUp" leave-active-class="slideOutDown">
    <div
      v-if="showHint"
      class="fixed border border-gray-300 shadow-2xl bottom-2 left-1/2 transform -translate-x-1/2 z-100 p-5 rounded-2xl bg-white sm:w-xs w-[80%]"
    >
      <div class="flex flex-col space-y-5 w-full">
        <BaseButton
          @click="startAdd"
          class="w-full"
          :label="$t('nav.links.new_artwork')"
        />
        <BaseButton
          @click="postPoneAdd"
          variant="secondary"
          :label="$t('common.maybe_later')"
        />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

const showHint = ref<boolean>(false);
const newArtStore = useNewArtworkStore();

const startAdd = () => {
  localStorage.setItem("lastHint", Date.now().toString());
  showHint.value = false;
  newArtStore.openNewArtwork();
};
const postPoneAdd = () => {
  localStorage.setItem("lastHint", Date.now().toString());
  showHint.value = false;
};

const SHOW_INTERVAL = 24 * 60 * 60 * 1000; // once a day
// const SHOW_INTERVAL = 1000; // test purposes only

const shouldShowHint = () => {
  const last = localStorage.getItem("lastHint");
  if (!last) return true;

  const lastTime = Number(last);
  const now = Date.now();

  return now - lastTime > SHOW_INTERVAL;
};

onMounted(() => {
  if (!shouldShowHint()) return;

  setTimeout(() => {
    showHint.value = true;
  }, 5000);
});
</script>
